import { render, staticRenderFns } from "./SettingsAccount.vue?vue&type=template&id=6bfd50bf&scoped=true"
import script from "./SettingsAccount.vue?vue&type=script&lang=js"
export * from "./SettingsAccount.vue?vue&type=script&lang=js"
import style0 from "./SettingsAccount.vue?vue&type=style&index=0&id=6bfd50bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfd50bf",
  null
  
)

export default component.exports